import styled from "styled-components";

import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: ${theme.font.poppins};

  @media screen and (max-width: 768px) {
    justify-content: flex-start;
    padding-top: 20px;
  }
`;

export const Title = styled.h1`
  color: ${theme.colors.blue100};
  font-size: ${theme.font.sizes.xlarge};
  font-weight: ${theme.font.xbold};
  max-width: 800px;
  text-align: center;

  hr {
    margin: 20px auto;
    color: ${theme.colors.blue400};
    border: 2px solid ${theme.colors.blue400};
    max-width: 53px;
  }

  @media screen and (max-width: 768px) {
    font-size: ${theme.font.sizes.large};
  }
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-top: 2.5rem;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    width: 100%;
  }

  @media screen and (min-width: 992px) {
    grid-template-columns: 1fr  1fr 1fr;
    gap: 1.5rem;
    max-width: 95%;

    svg {
      max-width: 45px;
    }
  }
`;
